import React, { useEffect } from 'react'
import { Button, Drawer, Form, Input, Radio, Switch } from 'antd-v4'
import { ISalesChannel } from './api'

interface Props {
  visible: boolean
  isSaving: boolean
  selectedChannel?: ISalesChannel
  onCancel: () => void
  onSubmit: (name: string, environment: 'US' | 'GL', active: boolean) => Promise<void>
}

export const ChannelFormModal = ({
  visible,
  isSaving,
  selectedChannel,
  onCancel,
  onSubmit,
}: Props) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (!visible) return

    form.setFieldsValue({
      name: selectedChannel?.name || '',
      environment: selectedChannel?.environment || 'US',
      active: selectedChannel?.active ?? true,
    })
  }, [form, visible, selectedChannel])

  return (
    <Drawer
      title={
        <div>
          <div>{selectedChannel ? `Edit ${selectedChannel.name}` : 'Add New Sales Channel'}</div>
          <div style={{ fontSize: 12, color: 'rgba(0,0,0,.45)', fontWeight: 400 }}>
            Create or update global sales channels for pricing menus.
          </div>
        </div>
      }
      maskClosable
      placement='right'
      closable
      width={450}
      onClose={onCancel}
      visible={visible}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        padding: '24px',
      }}
    >
      <Form
        form={form}
        layout='vertical'
        onFinish={async ({
          name,
          environment,
          active,
        }: {
          name: string
          environment: 'US' | 'GL'
          active: boolean
        }) => {
          await onSubmit(name.trim(), environment, active)
        }}
      >
        <Form.Item
          label='Display Name'
          name='name'
          rules={[
            { required: true, message: 'Display name is required' },
            { min: 2, message: 'Display name must be at least 2 characters' },
          ]}
        >
          <Input maxLength={80} placeholder='e.g. UberEats' />
        </Form.Item>

        <Form.Item
          label='Environment'
          name='environment'
          rules={[{ required: true, message: 'Environment is required' }]}
        >
          <Radio.Group>
            <Radio.Button value='US'>US</Radio.Button>
            <Radio.Button value='GL'>GL</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item label='Active' name='active' valuePropName='checked'>
          <Switch checkedChildren='Active' unCheckedChildren='Inactive' />
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
          <Button type='primary' loading={isSaving} onClick={() => form.submit()}>
            {selectedChannel ? 'Save' : 'Create'}
          </Button>
        </div>
      </Form>
    </Drawer>
  )
}
